import * as React from 'react';
import { IconChevronDownSmall16, IconChevronUpSmall16, Input as UIKitInput } from '@cian/ui-kit';
import * as styles from './Input.css';

interface IInputProps {
  open: boolean;
  text?: string;
  onClick(): void;
}

export const Input: React.VFC<IInputProps> = ({ open, text, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <UIKitInput
        readOnly
        size="M"
        value={text}
        rightAdornment={
          <div className={styles['arrow']}>
            {open ? <IconChevronUpSmall16 color="primary_100" /> : <IconChevronDownSmall16 color="primary_100" />}
          </div>
        }
      />
    </div>
  );
};
